import { Box } from '@mui/material'

const Ribbon = ({ color, label }) => (
  <Box
    sx={{
      position: 'absolute',
      top: 0,
      right: 12,

      aspectRatio: '1 / 1',

      transformOrigin: '100% 14px',
      transform: 'rotate(45deg) translate(50%, calc(100% - 160px))',
    }}
  >
    <Box
      sx={(theme) => ({
        p: theme.spacing(0.25, 8),

        backgroundColor: theme.palette[color].main,
        color: theme.palette[color].contrastText,

        boxShadow: 4,
      })}
    >
      {label}
    </Box>
  </Box>
)

export default Ribbon
